import { useEffect, useState } from 'react'

const getMatches = (query: string) =>
  typeof window !== 'undefined' && window.matchMedia ? window.matchMedia(query).matches : false

const useMediaQuery = (query: string) => {
  const [matches, setMatches] = useState<boolean>(() => getMatches(query))

  useEffect(() => {
    const mediaQuery = window.matchMedia(query)
    const handler = (event: MediaQueryListEvent) => setMatches(event.matches)
    setMatches(mediaQuery.matches)

    // Safari < 14 only supports the deprecated addListener API
    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener('change', handler)
      return () => mediaQuery.removeEventListener('change', handler)
    }
    mediaQuery.addListener(handler)
    return () => mediaQuery.removeListener(handler)
  }, [query])

  return matches
}

export default useMediaQuery
